/* Bull Ring Fabrics: the "wow" for the pure white Liquid Glass footer (2026-10-24, Abid). Styles: the last block of
   assets/brf-ft-glass.css. Loaded from snippets/brf-pdp-tidy.liquid.
   - When the footer (and the bull sign-off) scroll into view, the glass pieces float up one after another and a sweep of
     light crosses the "Follow the herd" capsule and the bull tile (classes brf-lg-in + is-lit).
   - On computers with a mouse, a soft light follows the pointer across the glass sheet (--mx/--my), and the piece under
     the pointer lights up where the pointer is (--lx/--ly) and tilts gently towards it (--rx/--ry).
   Nothing moves for people who ask for reduced motion; phones get the float-up and the sweep only.
   - It also measures the footer and the bull sign-off together, so one drifting light field runs behind both (2026-10-24).
   - It moves the "Bullring Fabrics club" sign-up into the top of the footer as a large glass card (2026-10-24).
   - It gives the club sign-up a friendly message for a mistyped email, and brings the four promises above the footer to life (2026-10-24). */
(function () {
  if (window.__brfFtLg) return; window.__brfFtLg = 1;
  var doc = document, mm = window.matchMedia;
  var reduce = mm && mm('(prefers-reduced-motion: reduce)').matches;
  var fine = mm && mm('(hover: hover) and (pointer: fine)').matches;
  var PIECES = 'footer.brf-ft .brf-signup__inner, footer.brf-ft .brf-ft__glass, footer.brf-ft .brf-ft__util a, footer.brf-ft .brf-ft__cols > *, footer.brf-ft .brf-ft__paywrap, .brf-flogo a.brf-flogo__mark[data-brf-flogo]';
  var TILT = 'footer.brf-ft .brf-signup__inner, footer.brf-ft .brf-ft__util a, footer.brf-ft .brf-ft__glass, .brf-flogo a.brf-flogo__mark[data-brf-flogo]';

  /* the "Bullring Fabrics club" sign-up (snippets/brf-email-signup) sits just above the footer: bring it inside the footer,
     at the top, so it shares the white glass and the drifting light (2026-10-24). Styles: snippets/brf-footer-logo.liquid */
  function club(ft) {
    var s = doc.getElementById('brf-signup'); if (!s || ft.contains(s)) return;
    var w = doc.createElement('div'); w.className = 'brf-ft__in brf-ft__club';
    w.appendChild(s); ft.insertBefore(w, ft.firstElementChild); ft.classList.add('brf-ft--club');
  }
  function init() {
    var ft = doc.querySelector('footer.brf-ft'); if (!ft || ft.__lg) return; ft.__lg = 1;
    var lg = doc.querySelector('.brf-flogo');
    club(ft);

    /* float-up, staggered */
    var ps = doc.querySelectorAll(PIECES), n = 0;
    for (var i = 0; i < ps.length; i++) {
      var inLogo = !!ps[i].closest('.brf-flogo');
      ps[i].classList.add('brf-lg-in');
      ps[i].style.setProperty('--d', (inLogo ? 120 : Math.min(n++, 10) * 70) + 'ms');
    }
    var lit = function (el) { if (el) el.classList.add('is-lit'); };
    if (reduce || !('IntersectionObserver' in window)) { lit(ft); lit(lg); }
    else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { lit(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      io.observe(ft); if (lg) io.observe(lg);
    }
    if (!fine || reduce) return;

    /* light that follows the pointer, and the tilt of the piece under it */
    var tilts = doc.querySelectorAll(TILT);
    for (var t = 0; t < tilts.length; t++) tilts[t].classList.add('brf-lg-tilt');
    var hot = null, ev = null, raf = 0;
    function cool(el) {
      if (!el) return;
      el.classList.remove('is-hot');
      el.style.removeProperty('--rx'); el.style.removeProperty('--ry'); el.style.removeProperty('--lx'); el.style.removeProperty('--ly');
    }
    function apply() {
      raf = 0; var e = ev; if (!e) return;
      var r = ft.getBoundingClientRect();
      ft.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      ft.style.setProperty('--my', (e.clientY - r.top) + 'px');
      var el = e.target && e.target.closest ? e.target.closest('.brf-lg-tilt') : null;
      if (el !== hot) { cool(hot); hot = el; if (el) el.classList.add('is-hot'); }
      if (!el) return;
      var b = el.getBoundingClientRect(), x = (e.clientX - b.left) / b.width, y = (e.clientY - b.top) / b.height;
      var max = b.width > 400 ? 1.5 : 6; /* the wide capsule only leans a little */
      el.style.setProperty('--lx', (x * 100).toFixed(1) + '%');
      el.style.setProperty('--ly', (y * 100).toFixed(1) + '%');
      el.style.setProperty('--ry', ((x - 0.5) * 2 * max).toFixed(2) + 'deg');
      el.style.setProperty('--rx', ((0.5 - y) * 2 * max).toFixed(2) + 'deg');
    }
    function move(e) { ev = e; if (!raf) raf = requestAnimationFrame(apply); }
    function leave() { ev = null; cool(hot); hot = null; }
    ft.addEventListener('pointermove', move, { passive: true });
    ft.addEventListener('pointerleave', leave);
    if (lg) { lg.addEventListener('pointermove', move, { passive: true }); lg.addEventListener('pointerleave', leave); }
  }
  /* one light field behind the footer and the bull sign-off: measure them together (see "One piece" in brf-ft-glass.css) */
  var jt = 0;
  function join() {
    var ft = doc.querySelector('footer.brf-ft'), lg = doc.querySelector('.brf-flogo'); if (!ft || !lg) return;
    var a = ft.getBoundingClientRect(), b = lg.getBoundingClientRect();
    var h = Math.round(b.bottom - a.top), off = Math.round(b.top - a.top);
    if (h <= 0 || off < 0) return;
    ft.style.setProperty('--lg-h', h + 'px'); lg.style.setProperty('--lg-h', h + 'px'); lg.style.setProperty('--lg-off', off + 'px');
    doc.documentElement.classList.add('brf-lg-joined');
    if (!ft.__lgRo && window.ResizeObserver) { ft.__lgRo = 1; var ro = new ResizeObserver(soonJoin); ro.observe(ft); ro.observe(lg); }
  }
  function soonJoin() { clearTimeout(jt); jt = setTimeout(join, 120); }

  /* one friendly message instead of the browser's warning bubble and Shopify's error line */
  var SAY = {
    empty: ["Pop your email in first – we can't post your 10% off by carrier pigeon 🐂"],
    bad: ["That email's come a bit unravelled 🧵 Try something like name@example.com",
          "Sew close! An email needs an @ and a dot – like name@example.com",
          "Hold your horses (well, bulls) 🐂 that email's missing a stitch – try name@example.com"],
    taken: ["Good news – you're already in the herd 🐂 Keep an eye on your inbox for our next drop."],
    other: ["Something snagged on our side 🧵 Please give it another go in a moment."]
  };
  var EMAIL = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function isClub(f) { return f && f.id === 'brf-signup-form'; }
  function nudge(f, text) {
    var n = f.querySelector('.brf-signup__nudge'), i = f.querySelector('.brf-signup__input');
    if (!n) {
      n = doc.createElement('p'); n.className = 'brf-signup__nudge'; n.id = 'brf-signup-nudge'; n.setAttribute('role', 'alert');
      var row = f.querySelector('.brf-signup__row');
      if (row) row.insertAdjacentElement('afterend', n); else f.appendChild(n);
    }
    n.textContent = text;
    n.classList.remove('is-in'); void n.offsetWidth; n.classList.add('is-in');
    if (i) {
      i.setAttribute('aria-invalid', 'true'); i.setAttribute('aria-describedby', 'brf-signup-nudge');
      i.classList.remove('is-wobble'); void i.offsetWidth; i.classList.add('is-wobble');
    }
  }
  function calm(f) {
    var n = f.querySelector('.brf-signup__nudge'), i = f.querySelector('.brf-signup__input');
    if (i) { i.removeAttribute('aria-invalid'); i.removeAttribute('aria-describedby'); }
    if (n) { n.classList.remove('is-in'); setTimeout(function () { if (n.parentNode && !n.classList.contains('is-in')) n.parentNode.removeChild(n); }, 260); }
  }
  /* Shopify's own error line (after a send) is swapped for the same friendly message */
  function fromServer(f) {
    var e = f.querySelector('.brf-signup__err'); if (!e || e.__brfSaid) return;
    e.__brfSaid = 1;
    var t = (e.textContent || '').toLowerCase();
    nudge(f, pick(/taken|already|exists|herd/.test(t) ? SAY.taken : /invalid|valid email|format|unravel|quite right|domain|space|empty|blank/.test(t) ? SAY.bad : SAY.other));
  }
  function guard() {
    var f = doc.getElementById('brf-signup-form'); if (!f || f.__brfGuard) return; f.__brfGuard = 1;
    f.noValidate = true; /* no browser warning bubble: we say it ourselves */
    var ip = f.querySelector('.brf-signup__input'); if (ip) { ip.removeAttribute('title'); ip.removeAttribute('pattern'); } /* no hover tip either */
    fromServer(f);
    new MutationObserver(function () { fromServer(f); }).observe(f, { childList: true, subtree: true });
    f.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('.brf-signup__input')) return;
      if (EMAIL.test((e.target.value || '').trim())) calm(f);
    });
  }
  window.addEventListener('submit', function (e) {
    var f = e.target; if (!isClub(f)) return;
    var i = f.querySelector('[name="contact[email]"]'); if (!i) return;
    var v = (i.value || '').trim();
    if (v && EMAIL.test(v)) { calm(f); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    nudge(f, pick(v ? SAY.bad : SAY.empty));
    try { i.focus({ preventScroll: true }); } catch (er) {}
  }, true);

  /* the four promises above the footer (Same-day dispatch, UK Customer Service, Free UK delivery, Secure Payments): the tiles
     float up one by one with a sweep of light, each icon plays its little animation (class is-play) as its tile arrives and
     again on hover, and on computers the tile under the pointer catches the light and tilts. Styles: item 8 in
     snippets/brf-footer-logo.liquid (2026-10-24) */
  function play(el) { el.classList.remove('is-play'); void el.offsetWidth; el.classList.add('is-play'); }
  function trust() {
    var s = doc.querySelector('[data-section-type="text-with-icons"]'); if (!s || s.__brfTi) return; s.__brfTi = 1;
    var its = s.querySelectorAll('.text-with-icons__item'); if (!its.length) return;
    if (reduce || !('IntersectionObserver' in window)) { s.classList.add('is-lit'); return; }
    for (var i = 0; i < its.length; i++) { its[i].classList.add('brf-lg-in'); its[i].style.setProperty('--d', (i * 90) + 'ms'); }
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return; io.disconnect(); s.classList.add('is-lit');
      Array.prototype.forEach.call(its, function (el, k) { setTimeout(function () { play(el); }, 380 + k * 140); });
    }, { threshold: 0.25 });
    io.observe(s);
    Array.prototype.forEach.call(its, function (el) { el.addEventListener('pointerenter', function () { play(el); }); });
    if (!fine) return;
    for (var j = 0; j < its.length; j++) its[j].classList.add('brf-lg-tilt');
    var hot = null;
    function off(el) { if (!el) return; el.classList.remove('is-hot'); ['--rx', '--ry', '--lx', '--ly'].forEach(function (p) { el.style.removeProperty(p); }); }
    s.addEventListener('pointermove', function (e) {
      var el = e.target.closest ? e.target.closest('.text-with-icons__item') : null;
      if (el !== hot) { off(hot); hot = el; if (el) el.classList.add('is-hot'); }
      if (!el) return;
      var b = el.getBoundingClientRect(), x = (e.clientX - b.left) / b.width, y = (e.clientY - b.top) / b.height;
      el.style.setProperty('--lx', (x * 100).toFixed(1) + '%'); el.style.setProperty('--ly', (y * 100).toFixed(1) + '%');
      el.style.setProperty('--ry', ((x - 0.5) * 8).toFixed(2) + 'deg'); el.style.setProperty('--rx', ((0.5 - y) * 8).toFixed(2) + 'deg');
    }, { passive: true });
    s.addEventListener('pointerleave', function () { off(hot); hot = null; });
  }

  function start() { init(); guard(); trust(); join(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', start);
  window.addEventListener('resize', soonJoin, { passive: true });
})();
